import { Schema as S } from "effect";
import { defineMessageUnion } from "foldkit/message";

import {
	listImportBatches,
	matchImport,
	pollImportJob,
	previewUndo,
	submitImportJob,
	undoImportBatch,
} from "../../api/commands/import";
import { MatchRow } from "../../api/schemas/import";
import { Dialog } from "../../widgets/dialog";
import { ResolutionAction } from "./model";

/**
 * Every result Message carries the session `generation` (KTD3); a result from
 * an older generation, or one that arrives after the wizard moved on, is
 * discarded.
 */
export const Message = defineMessageUnion({
	ChangedFile: { file: S.Option(S.instanceOf(File)) },
	/** `text` is None when the browser could not read the file at all. */
	CompletedReadFile: {
		name: S.String,
		text: S.Option(S.String),
		generation: S.Number,
	},
	ChangedFilter: { value: S.String },
	ChangedPage: { page: S.Number },
	ToggledRow: { rowId: S.Number },
	/** Select-all applies to the filtered set only. */
	ToggledSelectAll: {},
	ClickedContinue: {},
	CompletedMatch: {
		rows: S.Array(MatchRow),
		offset: S.Number,
		generation: S.Number,
		result: matchImport.Result,
	},
	ClickedRetryMatch: {},
	ClickedBack: {},
	ChoseResolution: {
		rowId: S.Number,
		action: ResolutionAction,
		targetRecordId: S.Option(S.String),
	},
	ClickedBulk: { action: ResolutionAction },
	ClickedConfirm: {},
	CompletedBatchId: { batchId: S.String, generation: S.Number },
	/** `attempt` is the submit retry this answers. */
	CompletedSubmit: {
		attempt: S.Number,
		generation: S.Number,
		result: submitImportJob.Result,
	},
	/** `attempt` is the run of consecutive poll failures this poll followed. */
	CompletedPoll: {
		attempt: S.Number,
		generation: S.Number,
		result: pollImportJob.Result,
	},
	ClickedRestart: {},
	/* -- History (R18) and undo (R19) ------------------------------------- */
	ClickedHistory: {},
	CompletedBatches: {
		generation: S.Number,
		result: listImportBatches.Result,
	},
	ClickedUndo: { batchId: S.String },
	CompletedUndoPreview: {
		batchId: S.String,
		generation: S.Number,
		result: previewUndo.Result,
	},
	GotDialogMessage: { message: Dialog.Message },
	ClickedConfirmUndo: {},
	/** Undo is chunked: `cursor` is the one this answer was asked for. */
	CompletedUndo: {
		batchId: S.String,
		cursor: S.NullOr(S.Number),
		generation: S.Number,
		result: undoImportBatch.Result,
	},
});
export type Message = typeof Message.Type;
